//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request, setQuestionLogicBlock, Base64 } from '@/tools/index.js'
import { jssdk, isIphonex } from '@runwork/runwork-help'
import pagerQuestion from '../question/pagerQuestion'
import allQuestion from '../question/allQuestion'
import { mapGetters, mapState } from 'vuex'
import defaultImg from '@/assets/images/submit.png'
export default {
  inject: ['reload'],
  name: 'detail',
  data() {
    return {
      isUpdate: false,
      typeList: ['sign', 'apply'],
      // 最后一题
      isLastQuestion: false,
      height: 120,
      // 第一题
      isFirstQuestion: true,
      // 用户已答题的答案
      userAnswers: [],
      // 是否已提交
      isSubmit: false,
      loading: false,
      params: {},
      startTime: 0,
      // 是否显示暂存按钮
      isShowTempButton: false,
      // 投票数据
      votes: [],
      // 是否进入问卷预览模式
      preview: '',
      // 是否多次填报
      limitSetting: '',
      // 当前列表状态 10未完成 20已完成 30已过期
      currentListStatus: Number,
      // 推送参数 完成状态 10未完成 20已完成 30已过期
      status: Number,
      // 多次填报类型问卷拿多种答案的参数
      tenantId: undefined,
      shareType: 'user',
      // 验证是否可提交版本号
      questionnaireVersion: 0,
      isQuestion: '',
      questionCreateTime: '',
      // 答题详情
      answer: null,
      // 是否显示分数详情
      isShowScore: false,
      // 当前是否是匿名
      anonymous: false,
      // 提交成功后下载到本地的图标
      downLoadfinishIcon: "",
      // detailloading
      detailLoading: null,
    }
  },
  props: {
    isPerview: {
      type: Boolean,
      default: false
    },
    previewData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    pagerQuestion,
    allQuestion
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    ...mapGetters(['questionnaireList', 'pager', 'questionnaireReturnData']),
    ...mapState(['colorOption', 'isViewDetails']),
    visibleQuestionList() {
      let questionnaireList = this.questionnaireList || []
      return questionnaireList.filter(item => {
        return item.v_visible && item.type !== 'section'
      })
    },
    answeredCount() {
      return this.visibleQuestionList.filter(item => {
        return item.v_answered
      }).length
    },
    getCounterWidth() {
      return (this.answeredCount / this.visibleQuestionList.length) * 100
    },
    readonly() {
      console.log('currentListStatus: ', this.currentListStatus)
      console.log('readonly.params: ', this.params)
      console.log('readonly.params: ', this.isQuestion)
      console.log(
        this.currentListStatus == 20 ||
          (this.params.limitSetting && !this.params.limitNumber) ||
          (this.params.status > 10 && !this.params.limitSetting)
      )
      return (
        this.currentListStatus == 20 ||
        (this.params.limitSetting && !this.params.limitNumber) ||
        (this.params.status > 10 && !this.params.limitSetting)
      )
    },
    questionnaireId() {
      return this.params.questionnaireId
    },
    getSubmitText() {
      console.log('colorOption: ', this.colorOption, this.readonly)
      if (this.colorOption) {
        const text = this.anonymous ? `匿名${this.colorOption.submitButtonText}` : this.colorOption.submitButtonText;
        return text;
      } else {
        const defaultText = this.anonymous ? '匿名提交' : '提交';
        return defaultText;
      }
    },
    getSubmitStyle() {
      return this.colorOption
        ? {
            backgroundColor: this.colorOption.submitButtonColor,
            color: this.colorOption.submitButtonTextColor
          }
        : ''
    },
    getNoQuestionStyle() {
      return this.visibleQuestionList.length < 1
        ? {
            height: `${this.height}px`
          }
        : ''
    },
    getBackground() {
      return this.colorOption
        ? {
            backgroundColor: this.colorOption.surveyBackgroundColor,
            opacity: this.colorOption.surveyBackgroundOpacity / 100
          }
        : ''
    },
    getSuccessText() {
      return this.colorOption
        ? this.colorOption.finishButtonText
        : '查看填写详情'
    },
    getSuccessImg() {
      return this.colorOption && this.colorOption.finishIcon
        ? this.downLoadfinishIcon
        : defaultImg
    },
    tempSaveVisible() {
      return (
        !this.params.limitSetting &&
        !this.readonly &&
        !this.isSubmit &&
        this.isShowTempButton &&
        this.shareType !== 'anonymous'
      )
    }
  },
  created() {
    if (this.$route.name === "detail") {
      this.detailLoading = new this.$Loading()
    }
  },
  async mounted() {
    setTimeout(() => {
      this.detailLoading && this.detailLoading.close()
    }, 6000);
    if (this.isViewDetails) {
      this.currentListStatus = 20;
    }
    // 如果url里带preview参数则进入问卷预览模式
    this.preview = this.$route.query.preview
    console.log('preview: ', this.preview, !this.preview)
    let height = this.$refs.detailPage.$el.offsetHeight
    console.log(height, 'height------')
    if (height > 600) {
      this.height = `${height / 2 - 64}`
    }
    // 监听预览数据
    if (this.preview) {
      if (this.isPerview) {
        this.getData(this.previewData)
      } else {
        window.addEventListener('message', this.getData, false)
      }
    }

    !this.preview && this.getUrlParams()
    if (this.shareType == 'common' && !this.isRunwork && this.platform != 3) {
      new this.$Dialog({
        title: '温馨提示',
        text: `请用润工作扫码打开`,
        theme: 'ios',
        isConfirm: false,
        okText: '确认',
        onOk: () => {
          let ua = navigator.userAgent.toLowerCase()
          let uaApp = ua ? ua.match(/BeStore/i) : '' // match方法返回的是对象
          let uaAndroid = /android/i.test(ua) // test返回的是true/false
          let uaIos = /iphone|ipad|ipod/i.test(ua)
          if (window.WeixinJSBridge) {
            window.WeixinJSBridge.call('closeWindow') // 微信
          } else if (window.AlipayJSBridge) {
            window.AlipayJSBridge.call('closeWebview') // 支付宝
          } else if (isLppzApp && uaAndroid) {
            window.obj.closePageLppzRequest('') // 安卓app
          } else if (isLppzApp && uaIos) {
            window.webkit.messageHandlers.closePageLppzRequest.postMessage('') //ios app
          } else {
            window.close()
          }
        },
        onCancel: () => {}
      })
      this.detailLoading && this.detailLoading.close()
      return
    }
    // 如果只有一道题，不做分页
    if (this.questionnaireList.length == 1) {
      this.$store.commit('setPager', false)
    }
    !this.preview && this.init()
  },
  watch: {
    previewData(val) {
      if (this.isPerview && val) {
        this.getData(val)
      }
    }
  },
  methods: {
    // 拉取预览数据
    getData(e) {
      console.log('当前版本: 0.0.11')
      console.log('message: ', e.data)
      // 填充预览数据
      let { questionnaireDto, appearanceSettingDto } = e.data.returnData
      console.log('questionnaireDto: ', questionnaireDto)
      console.log('appearanceSettingDto: ', appearanceSettingDto)
      this.$store.dispatch('pushPreviewData', questionnaireDto)
      this.$store.commit('setColorOption', appearanceSettingDto)
      this.addField()
      questionnaireDto &&
        window.removeEventListener('message', this.getData, false)
      this.detailLoading && this.detailLoading.close()
    },
    async init(flag) {
      // const loading = new this.$Loading()
      this.loading = true
      await this.$nativeBridgeReady()
        .then(() => {
          return this.initData(flag)
        })
        .then(() => {
          this.loading = false
          this.detailLoading && this.detailLoading.close()
          // 答题开始时间
          this.startTime = new Date().getTime()
        })
        .catch(err => {
          this.loading = false
          this.detailLoading && this.detailLoading.close()
          console.error('请求三个接口失败了...', err)
        })
    },
    getUrlParams() {
      console.log('$route.query: ', this.$route.query)
      // 待办推送的地址
      let { param } = this.$route.query
      if (param) {
        this.params = JSON.parse(Base64.decode(param))
      }
      const {
        questionnaireId = '',
        limitSetting,
        currentListStatus,
        tenantId,
        shareType = 'user',
        isQuestion
      } = this.$route.query
      const types = this.$route.query.shareType ? shareType : this.params.shareType;
      this.isQuestion = isQuestion
      this.limitSetting = limitSetting
      if (!this.isViewDetails) {
        this.currentListStatus = currentListStatus;
      }
      this.tenantId = tenantId
      this.shareType = types
      this.anonymous = types === "anonymous";
      if (isQuestion) {
        this.$set(this.params, 'isQuestion', isQuestion)
      }
      if (questionnaireId) {
        this.$set(this.params, 'questionnaireId', questionnaireId)
        return
      }
    },
    async initData(flag) {
      await this.getColorOption()
      if (!flag) {
        await this.getQuestionnaire()
      }
      let readonly =
        this.currentListStatus == 20 ||
        (this.params.limitSetting && !this.params.limitNumber) ||
        (this.params.status > 10 && !this.params.limitSetting)
      if (this.params.selfQuestionnaireId) {
        this.isUpdate = true
        this.tenantId = this.params.selfQuestionnaireId
        await this.getAnswer()
      } else {
        // if (!this.isQuestion || flag) {
        if (this.shareType !== 'anonymous' || flag) {
          if (!this.params.limitSetting && readonly) {
            await this.getAnswer()
          } else {
            readonly && (await this.getAnswer())
          }
        }
        // }
      }
      await this.getVote()
      this.addField()
    },
    addField() {
      // 添加前端字段  v_isParent 是否是父级 ， v_visible 是否显示 , v_answer 答案
      let questions = [...this.questionnaireList]
      questions.forEach(question => {
        let v_isParent = false // 是否属于父级题目，如果是，则改变值的时候需要再去遍历
        questions.forEach(_q => {
          if (_q.logic.blocks.list.length) {
            _q.logic.blocks.list.forEach(_li => {
              if (_li.questionId === question.tenantId) {
                v_isParent = true
              }
            })
          }
        })
        this.$set(question, 'v_isParent', v_isParent)
        this.$set(question, 'v_visible', true)
        this.$set(question, 'v_answered', false) // 是否已答
        // 挂用户答过的答案
        this.userAnswers.forEach(item => {
          if (item.tenantId == question.tenantId) {
            this.$set(question, 'v_answer', item)
            this.$set(question, 'v_answered', true)
            this.$set(question, 'v_answer_all', item);
          }
        })
        // 挂投票
        this.votes.forEach(v => {
          // 投票信息挂到问题上
          if (question.tenantId === v.subjectId) {
            this.$set(question, 'v_vote', v)
          }
        })
      })
      // 调用题目显示隐藏逻辑 改变原数据
      questions = setQuestionLogicBlock(questions)
      this.$store.commit('setQuestionnaire', questions)
    },
    scrollTo(mark) {
      const scrollDom = document.querySelector('.scroll-y')
      scrollDom.scrollTop =
        document.getElementById(`nav-${mark}`).offsetTop - scrollDom.offsetTop
    },
    // 获取题目
    getQuestionnaire() {
      return this.$store
        .dispatch('getQuestionnaire', {
          questionnaireId: this.questionnaireId,
          userCode: this.shareType != 'anonymous' ? this.user.ldap : ''
        })
        .then(() => {
          console.log('questionnaireReturnData: ', this.questionnaireReturnData)
          this.params.status = Number(this.questionnaireReturnData.status)
          this.params.limitSetting = this.questionnaireReturnData.limitSetting
          this.params.limitNumber = Number(
            this.questionnaireReturnData.limitNumber
          )
          this.isQuestion = this.params.isQuestion
          console.log('readonly：', this.readonly, this.params)
          const startTime = this.questionnaireReturnData.startDate
          const endTime = this.questionnaireReturnData.endDate
          this.questionnaireVersion = this.questionnaireReturnData.questionnaireVersion
          if (startTime) {
            let startDate = startTime.replace(/-/g, '/')
            const dateParse =
              new Date(startDate).getTime() - new Date().getTime()
            if (dateParse > 0) {
              this.params.status = 40
              new this.$Dialog({
                title: '温馨提示',
                text: `问卷未开始，开始时间：${startDate}`,
                theme: 'ios',
                isConfirm: false
              })
            }
          }
          if (endTime) {
            let endDate = endTime.replace(/-/g, '/')
            const dateParse = new Date(endDate).getTime() - new Date().getTime()
            if (dateParse < 0) {
              this.params.status = 30
            }
          }
          // 已过期页面给出提示
          if ([30].includes(this.params.status)) {
            new this.$Dialog({
              title: '温馨提示',
              text: `问卷已结束`,
              theme: 'ios',
              isConfirm: false
            })
          }

          let readonly =
            (this.params.limitSetting && !this.params.limitNumber) ||
            (this.params.status > 10 && !this.params.limitSetting)
          // 已完成页面给出提示
          if (
            this.shareType !== 'anonymous' &&
            [20].includes(this.params.status) &&
            readonly &&
            !this.currentListStatus && 
            !this.isViewDetails
          ) {
            let type = this.questionnaireReturnData.type
            let tip = !this.typeList.includes(type)
              ? '问卷已填答'
              : type == 'sign'
              ? '请勿重复签到'
              : '请勿重复报名'
            new this.$Dialog({
              title: '温馨提示',
              text: tip,
              theme: 'ios',
              isConfirm: false
            })
          }

          // 问卷已暂停发布，请刷新页面重试
          if (this.questionnaireReturnData.questionnaireStatus === 40) {
            new this.$Dialog({
              title: '温馨提示',
              text: `问卷已暂停发布，请刷新页面重试`,
              theme: 'ios',
              isConfirm: false
            })
          }

          // 问卷创建者已删除该问卷
          if (this.questionnaireReturnData.removed === 1) {
            new this.$Dialog({
              title: '温馨提示',
              text: `问卷创建者已删除该问卷`,
              theme: 'ios',
              isConfirm: false
            })
          }

          // 如果是已完成和已过期页面或者点击查看详情，关闭一页一题模式
          if (this.readonly || this.isViewDetails) {
            this.$store.commit('setPager', false)
          }
        })
    },
    async queryCreateTime() {
      if (!this.user || !this.user.ldap) {
        return
      }
      const loading = new this.$Loading()
      request('queryQuestionnaireCreateTime', {
        userCode: this.user.ldap,
        questionnaireId: this.questionnaireId,
        tenantId: this.tenantId
      })
        .then(res => {
          this.questionCreateTime = res
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 获取用户已经答过的答案
    async getAnswer() {
      var res = await request('getUserAnswer', {
        userCode: this.shareType != 'anonymous' ? this.user.ldap : '',
        questionnaireId: this.questionnaireId,
        tenantId: this.tenantId
      })
      const setting = res.questionnaireSetting;
      this.isShowScore = setting.displayScores === 1;
      console.log('getUserAnswer: ', this.tenantId)
      this.userAnswers = (res && res.questions) || []
      this.isShowTempButton = res && res.tempButton
      this.answer = res;
      // 把选项题的答案包装到currentValue里[tenantId1,tenantId2]
      this.userAnswers.forEach(answer => {
        if (answer.options && Array.isArray(answer.options)) {
          answer.currentValue = answer.options.map(i => {
            return i.tenantId
          })
        }
      })
    },
    // 获取投票
    getVote() {
      return request('getVoteData', {
        userCode: this.shareType != 'anonymous' ? this.user.ldap : '',
        questionnaireId: this.questionnaireId
      }).then(res => {
        console.log('getVoteData: ', res)
        this.votes = res
      })
    },
    // 获取问卷底色配置
    getColorOption() {
      this.$store.dispatch('getColorOption', {
        userCode: this.user.ldap,
        questionnaireId: this.questionnaireId
      })
    },
    closeWebApp() {
      let { param } = this.$route.query
      if (param) {
        let params = JSON.parse(Base64.decode(param))
        let { closeView } = params
        if (closeView == '1') {
          this.platform === 3
            ? window.tt.closeWindow({})
            : crh.closeWebApp()
        } else {
          !this.preview && this.$router.go(-1)
        }
      } else {
        !this.preview && this.$router.go(-1)
      }
      this.$store.commit('setIsViewDetails', false);
    },
    onNextPageClicked() {
      this.isFirstQuestion = false
      this.$refs.pagerQuestion.onNextClicked()
    },
    onPrevPageClicked() {
      this.isLastQuestion = false
      this.$refs.pagerQuestion.onPrevClicked()
    },
    lastOneHandle() {
      this.isLastQuestion = true
    },
    firstOneHandle() {
      this.isFirstQuestion = true
    },
    middleOneHandle() {
      this.isFirstQuestion = false
      this.isLastQuestion = false
    },
    // 暂存
    onSaveTemp() {
      // 预览模式屏蔽提交操作
      !this.preview
        ? this.saveAnswer('subTemp')
        : new this.$Toast({ text: '预览模式无法提交' })
    },
    //提交
    async onSubmitClicked() {
      console.log('onSubmitClicked-questionnaireList: ', this.questionnaireList)
      let check = false
      if (this.pager) {
        check = await this.$refs.pagerQuestion.validateAnswer()
      } else {
        var checkList = await this.$refs.allQuestion.validateAnswer()
        check = checkList.every(item => {
          return item
        })
      }
      if (!check) {
        new this.$Toast({
          text: '请先完善"必填项"',
          time: 1500,
          position: 'top',
          distance: '50%'
        })
        return
      }
      let type = this.questionnaireReturnData.type
      // let text = !this.typeList.includes(type)
      //   ? '是否提交问卷？'
      //   : type == 'sign'
      //   ? '是否确认签到？'
      //   : '是否确认报名？'
      let text = "";
      if (!this.typeList.includes(type)) {
        text = '是否提交问卷？';
        // 提交问卷
        new this.$Dialog({
          title: '提示',
          text: text,
          confirm: true,
          cancelText: '取消',
          okText: '确认',
          onOk: () => {
            this.submitHanlder();
          },
          onCancel: () => {}
        })
      } else {
        this.submitHanlder();
      }
    },
    submitHanlder() {
      // 预览模式屏蔽提交操作
      let isToast = false
      if (!this.preview) {
        if (this.isQuestion == 1) {
          isToast = true
        } else {
          isToast = false
        }
      } else {
        isToast = true
      }
      if (isToast) {
        new this.$Toast({ text: '预览模式无法提交' })
      } else {
        if (
          this.params.limitSetting &&
          !this.params.limitNumber &&
          this.shareType != 'anonymous'
        ) {
          new this.$Toast({ text: '你已达到该问卷最大填报次数' })
        } else {
          this.saveAnswer('sub')
        }
      }
    },
    saveAnswer(type) {
      type = !this.isUpdate ? type : type == 'sub' ? 'update' : type
      const loading = new this.$Loading()
      const answers = this.questionnaireList
        .filter(q => {
          return q.v_visible && q.v_answered
        })
        .map(q => {
          return q.v_answer
        })
      console.log('answers: ', answers)
      const timer = new Date().getTime() - this.startTime
      let params = {
        userCode: this.shareType != 'anonymous' ? this.user.ldap : '',
        questionnaireId: this.questionnaireId,
        saveType: type,
        questions: answers,
        shareType: this.shareType,
        type: this.questionnaireReturnData.type,
        timer: timer,
        questionnaireVersion: this.questionnaireVersion,
        selfToken: this.params.selfToken
      }
      if (this.params.selfQuestionnaireId) {
        params['tenantId'] = this.params.selfQuestionnaireId
      }
      request('saveUserAnswer', params)
        .then(res => {
          this.tenantId = res
          if (type == 'subTemp') {
            new this.$Toast({
              text: '暂存成功',
              time: 1500,
              position: 'top',
              distance: '50%'
            })
          } else {
            this.queryCreateTime()
            this.isSubmit = true
            // 提交成功后，如果图标不为空，则下载
            if (this.colorOption && this.colorOption.finishIcon) {
              this.downFile();
            }
          }
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    onBackClicked() {
      this.$router.push('/home');
      this.$store.commit('setIsViewDetails', false);
    },
    onSeeDetailClicked() {
      this.isSubmit = false
      this.isQuestion = ''
      // 由于适配问卷多次填报逻辑 需要传递标识位参数 故此方法废弃--该注释是之前的注释，暂时不删除
      // 最新逻辑，不管当前是单次润卷填报或者多次，都不做区分，点击查看详情按钮，只显示润卷答完题的列表，只供查看
      // 具体做法，当前页面刷新(router-view-v-if),页面重新初始化直接接口，此时接口判断润卷为已答题
      this.reload();
      this.$store.commit('setIsViewDetails', true);
      // this.init(true)
      // this.currentListStatus = 20
    },
    // 下载文件
		downFile() {
      const id = this.colorOption.finishIcon.split("fileId=")[1];
			this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: id
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        this.downLoadfinishIcon = blobUrl;
      });
		}
  }
}
